<sc-master-detail [readOnly]="!manageArticleTypePermitted" [data]="data" [selection]="[selected]" [showDelete]="false" (selectionChanged)="onSelectionChanged($event);"
      (addEntry)="onAddEntry($event);">

      <sc-padding fitHeight *ngIf="selected">
          <sc-flex vertical fitHeight stretchContent>
            <div>
              <sc-flex [centered]="true">
              <sc-title>
                <sc-dictionary-label dictionaryKey="erp.ui.articletype.title"></sc-dictionary-label>
              </sc-title>
              <sc-content-spacer grow></sc-content-spacer>
                  <button mat-stroked-button (click)="onCancel()">
                      <mat-icon><sc-icon iconClass="fa-xmark"></sc-icon></mat-icon>
                      <sc-dictionary-label dictionaryKey="erp.ui.articletype.action.cancel"></sc-dictionary-label>
                  </button>
                  <sc-content-spacer></sc-content-spacer>
                  <button mat-flat-button (click)="onSave()" [disabled]="saveDisabled()">
                      <mat-icon><sc-icon iconClass="fa-save"></sc-icon></mat-icon>
                      <sc-dictionary-label dictionaryKey="erp.ui.articletype.action.save"></sc-dictionary-label>
                  </button>
                </sc-flex>
            </div>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-bordered-tile>
                  <sc-padding>
                      <app-article-type-masterdata [articleType]="selected"></app-article-type-masterdata>
                  </sc-padding>
              </sc-bordered-tile>
              <sc-content-spacer vertical [double]="true"></sc-content-spacer>
              <sc-flex-fitting-content vertical>
                  <sc-scroll-pane>
                      <sc-sub-title>
                          <sc-dictionary-label dictionaryKey="erp.ui.articletype.subtitle.attributes"></sc-dictionary-label>
                          <sc-content-spacer grow></sc-content-spacer>
                          <button mat-stroked-button (click)="addAttributeGroup()">
                              <mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon>
                              <sc-dictionary-label dictionaryKey="erp.ui.articletype.action.add-group"></sc-dictionary-label>
                          </button>
                          <sc-content-spacer *ngIf="selected.attributeGroups.length > 0"></sc-content-spacer>
                          <button mat-stroked-button (click)="addAttribute()" *ngIf="selected.attributeGroups.length > 0">
                              <mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon>
                              <sc-dictionary-label dictionaryKey="erp.ui.articletype.action.add-attribute"></sc-dictionary-label>
                          </button>
                      </sc-sub-title>
                      <sc-content-spacer vertical [half]="true"></sc-content-spacer>
                      <sc-bordered-tile>
                          <app-article-type-attribute-list [articleType]="selected"
                              [editAttributeGroupFunction]="editAttributeGroup" [removeAttributeGroupFunction]="removeAttributeGroup"
                              [editAttributeFunction]="editAttribute" [removeAttributeFunction]="removeAttribute"></app-article-type-attribute-list>
                      </sc-bordered-tile>
                      <sc-content-spacer vertical [double]="true"></sc-content-spacer>
                      <sc-sub-title>
                          <sc-dictionary-label dictionaryKey="erp.ui.articletype.subtitle.calculationrules"></sc-dictionary-label>
                          <sc-content-spacer grow></sc-content-spacer>
                          <button mat-stroked-button (click)="addCalculationRule()">
                              <mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon>
                              <sc-dictionary-label dictionaryKey="erp.ui.articletype.action.add-calculationrule"></sc-dictionary-label>
                          </button>
                      </sc-sub-title>
                      <sc-content-spacer vertical [half]="true"></sc-content-spacer>
                      <sc-bordered-tile>
                          <app-article-type-calculation-rule-list [articleType]="selected" [calculationRules]="selected?.calculationRules"
                              [editCalculationRuleFunction]="editCalculationRule" [removeCalculationRuleFunction]="removeCalculationRule">
                          </app-article-type-calculation-rule-list>
                      </sc-bordered-tile>
                      <sc-content-spacer vertical [double]="true"></sc-content-spacer>
                      <sc-sub-title>
                          <sc-dictionary-label dictionaryKey="erp.ui.articletype.subtitle.basicarticledefinition"></sc-dictionary-label>
                          <sc-content-spacer grow></sc-content-spacer>
                          <button mat-stroked-button (click)="editBaseArticleDefinition()">
                              <mat-icon><sc-icon iconClass="fa-pencil"></sc-icon></mat-icon>
                              <sc-dictionary-label dictionaryKey="erp.ui.articletype.action.change-basicarticledefinition"></sc-dictionary-label>
                          </button>
                      </sc-sub-title>
                      <sc-content-spacer vertical [half]="true"></sc-content-spacer>
                      <sc-bordered-tile>
                          <app-article-type-base-article-definition-list [definition]="selected?.completeArticleType?.basicArticleDefinition">
                          </app-article-type-base-article-definition-list>
                      </sc-bordered-tile>
                      <sc-content-spacer vertical [double]="true"></sc-content-spacer>

                  </sc-scroll-pane>
              </sc-flex-fitting-content>
          </sc-flex>
      </sc-padding>

  </sc-master-detail>
